<div #card class="card-header px-5 py-4">
  <h3 tabindex="0">
    {{ messages.getText('ADVICE.' + prefix + '.' + config.id + '.title') }}
    @if (recommendation?.status !== null && recommendation?.status !== 'NOT_ANSWERED') {
      <div class="status-icon" aria-hidden="true">
        <i class="fa" aria-hidden="true"
           [ngClass]="{ 'fa-check-circle' : recommendation?.status === 'ACCEPTED', 'fa-times-circle': this.recommendation?.status === 'REJECTED' }">
        </i>
      </div>
    }
  </h3>
</div>

<div class="card-body px-5 pb-5" tabindex="0">
  @if (DEBUG) {
    <div class="alert alert-query" role="alert">
      <p><b>DEBUG ID:</b>&nbsp;&nbsp;<span class="badge bg-secondary">{{ recommendation.name }}</span></p>
    </div>
  }
  <div class="mt-3 col-7" [innerHTML]="messages.getText('ADVICE.' + prefix + '.' + config.id + '.risk')"></div>
  <h4 class="mt-3 col-7">{{ messages.getText('ADVICE.our-recommendation') }}</h4>
  <div class="mt-1 col-7"
       [innerHTML]="messages.getTextInterpolate('ADVICE.' + prefix + '.' + config.id + '.solution', [config.price])"
  ></div>
  @if (flagAsInvalid) {
    <div class="alert alert-danger error pill form-error-list">
      <div class="error-list-wrapper" id="err" aria-live="assertive">
        <ul>
          <li>
            <span>
              {{ messages.getText('ADVICE.error.answer', 'Please select an answer') }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  }
  <div class="row">
    <div ngbDropdown placement="top-end" class="dropdown">
      <button ngbDropdownToggle
              class="btn primary dropdown-toggle rounded-pill"
              [class.rejected]="recommendation?.status === 'REJECTED'"
              [class.accepted]="recommendation?.status === 'ACCEPTED'"
              type="button"
              id="decision.{{ config.id }}"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false">
        {{ messages.getText('ADVICE.button.status.' + recommendation?.status, '--please select --') }}@if(recommendation?.status === 'REJECTED') {, {{ messages.getText(config.rejectionOptions?.get(recommendation.rejectionCode!)!).toLowerCase() }} }
        <img class="mx-2" src="https://bequeathedassets.s3.eu-west-2.amazonaws.com/myintent/icons/dropdown_roundel_green.svg" alt="Green dropdown arrow">
      </button>
      <div ngbDropdownMenu
           [attr.aria-labelledby]="'decision.' + config.id"
           [class.rejected]="recommendation?.status === 'REJECTED'"
      >
        <button ngbDropdownItem (click)="updateStatus('ACCEPTED')">{{ messages.getText('ADVICE.button.accept') }}</button>
        @for (option of config.rejectionOptions | keyvalue; track $index) {
          <button ngbDropdownItem (click)="updateStatus('REJECTED', option.key)">
            {{ messages.getText('ADVICE.button.reject') }}, {{ messages.getText(option.value) }}
          </button>
        }

      </div>
      <app-confirm-popup #confirmPopup (confirmAction)="scroll(card)">
        <div [innerHTML]="messages.getText('dialog.recommendations.popup-information')"></div>
        <div [innerHTML]="messages.getText('ADVICE.' + prefix + '.popup.description')"></div>
      </app-confirm-popup>
    </div>
  </div>
  @if (recommendation?.status === 'REJECTED' && rejectionCodeIsOther()) {
    <div class="mt-2 row">
      <textarea #rejectionText class="form-control form-text rejection-text d-inline-block" [(ngModel)]="recommendation.rejectionText"></textarea>
    </div>
  }
</div>
